import { Button, Dropdown, message } from "antd";
import type { ItemType, MenuInfo } from "rc-menu/lib/interface";
import { useNavigate } from "react-router-dom";
import {
  useActivateFinishedGoodsMutation,
  useDeleteFinishedGoodsMutation,
} from "../../services/api";

interface Props {
  record: any;
  selectedValue: string;
  setOpen: (data: boolean) => void;
  setDrawerContent: (data: any) => void;
}

export const ActionDropdown = ({
  record,
  selectedValue,
  setOpen,
  setDrawerContent,
}: Props) => {
  const navigate = useNavigate();

  const [deactivateWarehouse, { isLoading: deactivatingLoading }] =
    useDeleteFinishedGoodsMutation();
  const [activateWarehouse, { isLoading: activateLoading }] =
    useActivateFinishedGoodsMutation();
  const userRole = localStorage.getItem("user_role");

  const handleDeleteWarehouse = async () => {
    try {
      await deactivateWarehouse(record.id).unwrap();
      message.success("Warehouse deactivated successfully");
      navigate("/finished-goods");
    } catch (err: any) {
      message.error(err?.message || "Failed to deactivate");
    } finally {
    }
  };

  const handleActivateWarehouse = async () => {
    try {
      await activateWarehouse({
        id: record.id,
        body: { is_active: true, is_deleted: false },
      }).unwrap();
      message.success("Warehouse activated successfully");
      navigate("/finished-goods");
    } catch (err: any) {
      message.error(err?.message || "Failed to activate");
    } finally {
    }
  };

  const items: ItemType[] = [
    record.is_active && userRole !== "2" && userRole !== "1"
      ? {
          key: "1",
          label: <Button type="ghost">Update</Button>,
        }
      : null,
    {
      key: "5",
      label: (
        <Button
          type="ghost"
          onClick={() => {
            setDrawerContent("preview");
            setOpen(true);
          }}
        >
          Preview
        </Button>
      ),
    },
    userRole !== "2" && userRole !== "1"
      ? {
          key: "2",
          label: record.is_active ? (
            <Button type="ghost" loading={deactivatingLoading}>
              Deactivate
            </Button>
          ) : (
            <Button type="ghost" loading={activateLoading}>
              Activate
            </Button>
          ),
        }
      : null,
    record.is_active && userRole !== "3" && userRole !== "4"
      ? {
          key: "3",
          label: (
            <Button
              type="ghost"
              onClick={() => {
                setOpen(true);
                setDrawerContent("add");
                // navigate(
                //   `/finished-goods?id=${record.id}&type=${selectedValue}&item=${record.name.name}`
                // ); // Open the drawer in preview mode
              }}
            >
              Reserve this product
            </Button>
          ),
        }
      : null,
    record.is_active && (userRole === "3" || userRole === "4")
      ? {
          key: "4",
          label: <Button type="ghost">Add Log Entry</Button>,
        }
      : null,
  ].filter(Boolean);

  const handleClick = (info: MenuInfo) => {
    if (info.domEvent instanceof MouseEvent) {
      info.domEvent.stopPropagation();
    }

    switch (info.key) {
      case "1":
        navigate(`/add-goods?id=${record.id}&type=${selectedValue}`);
        break;
      case "2":
        if (record.is_active) {
          handleDeleteWarehouse();
        } else {
          handleActivateWarehouse();
        }
        break;
      case "3":
        navigate(
          `/finished-goods?id=${record.id}&type=${selectedValue}&item=${record?.name?.name}`
        );
        break;
      case "4":
        navigate(
          `/finished-goods?id=${record.id}&type=${selectedValue}&item=${record?.name?.name}&log=true`
        );
        break;
      case "5":
        navigate(
          `/finished-goods?id=${record.id}&type=${selectedValue}&item=${record?.name?.name}`
        );

        setDrawerContent("preview");
        setOpen(true);

        break;
      default:
        break;
    }
  };

  return (
    <Dropdown
      menu={{ items, onClick: handleClick }}
      placement="bottomLeft"
      trigger={["click"]}
    >
      <img
        className="cursor-pointer"
        src="/assets/dots.svg"
        onClick={(e) => e.stopPropagation()}
      />
    </Dropdown>
  );
};
